export const UPDATE_PAYMENT_FLOW_STEP_ONE: any = {
  flow_slug: 'updatePaymentFlow',
  flow_version: 1,
  uuid: 'update_payment_flow_step_one',
  subtext: '',
  layout: '',
  settings: {
    submit_label: 'Save details',
    align: 'center',
    update_payment_details: true
  },
  heading: 'Update your payment details',
  sections: [
    {
      uuid: 'policy_details_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Policy you’re updating',
      elements: [
        {
          uuid: 'policy_details_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'policy_details_review',
          type: 'string',
          required: false
        },
      ]
    },
    {
      uuid: 'payment_review_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Current payment details',
      elements: [
        {
          uuid: 'payment_details_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        },
      ]
    },
    {
      uuid: 'update_payment_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: 'management-updatepayment'
      },
      heading: 'New payment details',
      elements: [
        {
          uuid: 'payment_method',
          type: 'payment',
          key: 'payment_method',
          subtext: '',
          layout: 'payment',
          settings: {
            payment_options: [],
            locale: {}
          },
          prompt: '',
          required: true
        },
        {
          uuid: 'credit_card_opt_in',
          type: 'confirm',
          key: 'confirmed_card_permission',
          subtext: '',
          layout: '',
          settings: {
            text: 'I confirm that I am the cardholder, or I have permission from the cardholder to use this card and to authorise {{partner}} to save the card details.',
            align: 'center',
            value: 'true',
            css_class: 'padding-none'
          },
          show_if: {
            operands: ['<payment_type>', 'credit_card'],
            operator: 'eq'
          },
          prompt: '',
          required: true
        },
        {
          uuid: 'direct_debit_opt_in',
          subtext: '',
          layout: '',
          settings: {
            text: 'I confirm I am the account holder, or have the permission of the account holder to save, use and update these account details for purchases with Open Insurance Pty Ltd. I confirm that Open Insurance Pty Ltd may charge future insurance premiums for this policy to the above account.',
            align: 'center',
            value: 'true',
            css_class: 'padding-none'
          },
          show_if: {
            operands: [
              {
                operands: ['<payment_type>', 'direct_debit'],
                operator: 'eq'
              },
              {
                operands: ['<payment_method.gocardless.account_created>', true],
                operator: 'not_eq'
              }
            ],
            operator: 'all'
          },
          prompt: '',
          key: 'confirmed_direct_debit_permission',
          type: 'confirm',
          required: true
        }
      ]
    }
  ],
  interstitial: {
    type: 'default',
    settings: {
      icon: '/assets/svgs/common/loading-blue.svg',
      time: 6000
    },
    heading: 'Updating your payment details'
  },
  data: {
    _flow_metadata: {
      current_page_uuid: 'update_payment_flow_step_one'
    }
  },
  human: {},
  progress: 1,
  total_pages: 2,
  actions: {
    back: {},
    next: {}
  },
  analytics: {
    flow_slug: 'updatePaymentFlow',
    flow_version: 1,
    page_uuid: 'update_payment_flow_step_one',
    policy_slug: '',
    user_slug: '',
    payment_type: ''
  }
};

export const UPDATE_PAYMENT_FLOW_STEP_TWO: any = {
  flow_slug: 'updatePaymentFlow',
  flow_version: 1,
  uuid: 'update_payment_flow_step_two',
  subtext: '',
  layout: '',
  settings: {
    submit_label: 'Return to dashboard',
    align: 'center',
    tracking: [
      {
        action: 'payment_method.change',
        options: {
          is_agent: false
        },
        type: 'survicate'
      }
    ]
  },
  heading: 'Your payment details have been updated',
  sections: [
    {
      uuid: 'payment_outstanding_info',
      subtext: '',
      layout: '',
      settings: {
        card: false,
        hero: ''
      },
      heading: '',
      elements: [
        {
          uuid: 'payment_outstanding_info',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        }
      ]
    },
    {
      uuid: 'policy_details_success_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Your policy',
      elements: [
        {
          uuid: 'policy_details_success_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'policy_details_review',
          type: 'string',
          required: false
        }
      ]
    },
    {
      uuid: 'payment_review_success_section',
      subtext: '',
      layout: '',
      settings: {
        card: true,
        hero: ''
      },
      heading: 'Payment details',
      elements: [
        {
          uuid: 'payment_details_success_review',
          subtext: '',
          layout: 'review',
          info: {
            type: 'string',
            heading: '',
            content: '',
            settings: {
              align: 'top',
              show_info: true
            }
          },
          settings: {
            read_only: true
          },
          prompt: '',
          key: 'payment_details_review',
          type: 'string',
          required: false
        }
      ]
    }
  ],
  data: {
    _flow_metadata: {
      current_page_uuid: 'update_payment_flow_step_two'
    }
  },
  human: {},
  progress: 2,
  total_pages: 2,
  actions: {
    next: {}
  },
  analytics: {
    flow_slug: 'updatePaymentFlow',
    flow_version: 1,
    page_uuid: 'update_payment_flow_step_two',
    policy_slug: '',
    user_slug: '',
    payment_type: ''
  }
};
